import {gql} from '@apollo/client';

export const FETCH_BASKET_VOUCHERS = gql`
  query fetchBasketVouchers($lang: String!, $storeId: String!, $itemDetails: [BasketItemDetailInput!]!) {
    fetchBasketVouchers(lang: $lang, storeId: $storeId, itemDetails: $itemDetails) {
      selected {
        cId
        title
        image
        banner
        skus
        discount
        expiryDate
        minimumOrderAmount
        voucherCode
        points
      }
      unselected {
        cId
        title
        image
        banner
        skus
        discount
        expiryDate
        minimumOrderAmount
        voucherCode
        points
      }
      others {
        cId
        title
        image
        banner
        skus
        discount
        expiryDate
        minimumOrderAmount
        voucherCode
        points
      }
    }
  }
`;
